module.exports= {
    "postbox-text": "Escriure lo comentari aquí (almens 3 caractèrs)",
    "postbox-author": "Nom (opcional)",
    "postbox-email": "Corrièl (opcional)",
    "postbox-website": "Site web (opcional)",
    "postbox-preview": "Apercebut",
    "postbox-edit": "Modificar",
    "postbox-submit": "Enviar",
    "postbox-notification": "S'abonar per corrièl a las notificacions de responsas",

    "num-comments": "Un comentari\n{{ n }} comentaris",
    "no-comments": "Cap de comentari pel moment",
    "atom-feed": "Flux Atom",

    "comment-reply": "Respondre",
    "comment-edit": "Modificar",
    "comment-save": "Salvar",
    "comment-delete": "Suprimir",
    "comment-confirm": "Confirmar",
    "comment-close": "Tampar",
    "comment-cancel": "Anullar",
    "comment-deleted": "Comentari suprimit.",
    "comment-queued": "Comentari en espèra de moderacion.",
    "comment-anonymous": "Anonim",
    "comment-hidden": "1 rescondut\n{{ n }} resconduts",

    "date-now": "ara meteis",
    "date-minute": "fa una minuta \nfa {{ n }} minutas",
    "date-hour": "fa una ora\nfa {{ n }} oras",
    "date-day": "Ièr\nfa {{ n }} jorns",
    "date-week": "la setmana passada\nfa {{ n }} setmanas",
    "date-month": "lo mes passat\nfa {{ n }} meses",
    "date-year": "l'an passat\nfa {{ n }} ans"
};
